import {useParams} from 'react-router-dom'
import React, { useState } from 'react';

import {SVTPOrderCom} from '../containers'
function SVTPOrderComPage() {
    let { id } = useParams();
    let svparams = { 'id': id}
    return (
        <SVTPOrderCom svparams= {svparams} />
    );
}
export default SVTPOrderComPage